import { IOrganization } from "@/api";
import { Button } from "@/components/shared/buttons/Button";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";

interface IProps {
    /**
     * The organization to view all scopes for
     */
    organization: IOrganization;
}

/**
 * A button to view all scopes for an organization
 */
export const ViewAllScopesButton = ({ organization }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy({
        navigationPath: "/organizations/scopes",
    });

    return (
        <Button
            variant="contained"
            color={"inherit"}
            sx={{ borderRadius: 29 }}
            onClick={() => proxyIntoOrganization(organization.id)}
            loading={isPending}
            disableElevation
        >
            View All
        </Button>
    );
};
